export function createDebouncedTask(
  task,
  delay,
  {
    setTimer = (callback, timeout) => setTimeout(callback, timeout),
    clearTimer = (timer) => clearTimeout(timer)
  } = {}
) {
  let timer = null;

  const schedule = (...args) => {
    if (timer !== null) clearTimer(timer);
    timer = setTimer(() => {
      timer = null;
      task(...args);
    }, delay);
    return timer;
  };

  schedule.cancel = () => {
    if (timer !== null) clearTimer(timer);
    timer = null;
  };
  schedule.pending = () => timer !== null;

  return schedule;
}
